import { Button } from "@mui/material";
import { deviceSpec } from "breakpoints";
import { styled } from "styled-components";

export const HomeToolbarContainer = styled('div')`
  margin-top: 1em;
  display: flex;
  flex-wrap: wrap;

  @media ${deviceSpec.isTablet} {
    margin-top: 0px;
  }
`;

export const HomeToolbarInner = styled('div')`
  display: flex;
  flex-direction: row;
  flex: 0 0 66%;
  max-width: 65%;
  justify-content: space-between;

  div:first-child {
    padding-right: 1em;
    border-radius: 46px !important;
  }
`;

export const Filters1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > button:nth-child(1) {
    margin-right: 1em;
  }

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`

export const Filters2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  .MuiButtonBase-root {
    border: 1px solid ${({theme}) => theme.colors.lightGreyRgba} !important;
  }

  .MuiButtonBase-root:hover {
    border: 1px solid ${({theme}) => theme.colors.actionButtonColorHvr} !important;
  }

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`